export const LOGIN_TYPES = {
  SHOP: 'shop',
  MANAGEMENT: 'management',
  JOURNEY: 'journey'
}

export function getLoginType () {
  return sessionStorage.getItem('loginType') || LOGIN_TYPES.MANAGEMENT
}

export function isShopLogin () {
  return getLoginType() === LOGIN_TYPES.SHOP
}

export function isManagementLogin () {
  return getLoginType() === LOGIN_TYPES.MANAGEMENT
}

export function isJourneyLogin () {
  return getLoginType() === LOGIN_TYPES.JOURNEY
}



// WEBPACK FOOTER //
// ./src/utils/auth.js